module.exports = "<app-register-1 (FormEvent1)=\"FormForm1($event)\" *ngIf=\"!showForm2\" (needChurch)=\"requestChurch($event)\" ></app-register-1>\n<app-register-2 (FormEvent2)=\"FormForm2($event)\" *ngIf=\"showForm2\"></app-register-2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/register/register.component.html
// module id = ./src/app/pages/register/register.component.html
// module chunks = main